/* md-patches.js - comportamento do bloco de patches da PDP (Match Day).
 *
 * ============================ A CONVENCAO DOS ATRIBUTOS ============================
 * (a mesma do md-patch-labels.js e do md-patches-carrinho; da pra conferir no HTML servido)
 *
 *   data-md-patches               <fieldset> raiz do bloco
 *   data-md-patches-form="<id>"   <fieldset> id do <form> de add to cart ao qual o bloco pertence
 *   data-md-patch-codigo="P41"    <input>    qual patch este checkbox seleciona
 *   data-md-patch-local="Chest"   <input>    local GRAVADO (grupo de exclusividade)
 *   data-md-patch-texto="P41"     <span>     ALVO: o Worker escreve o texto aqui dentro
 *   data-md-patch-campo="n"|"l"   <span>     "n" = nome do patch, "l" = local exibido
 *   data-md-patch-ok                         marca que o md-patch-labels.js poe no alvo pintado
 *
 * SO se pinta o que tem `data-md-patch-texto`. Os atributos do <input> nunca sao pintados.
 *
 * ============================== O QUE ESTE ARQUIVO FAZ ==============================
 * 1. exclusividade dentro do mesmo local, multiplo entre locais, clique no marcado desmarca;
 * 2. resumo dos marcados no rotulo do topo, na ordem do DOM;
 * 3. total corrente do preco, escolhendo um valor JA FORMATADO pelo Liquid.
 *
 * ============================ O QUE ESTE ARQUIVO NAO FAZ ============================
 * - NAO intercepta o add to cart. Quem faz isso e o snippet md-patches-carrinho, que roda
 *   em todas as paginas e tambem cuida da reconciliacao. Ter DOIS interceptadores de submit
 *   era a duplicidade que este conjunto existe pra nao ter: dariam dois POST de /cart/add
 *   por clique, que e exatamente o bug do AddToCart duplicado da Vaurie.
 * - NAO escreve campo escondido nenhum. As propriedades do pedido (Patches, _md_patches,
 *   _md_tie) sao montadas pelo interceptador, no corpo JSON, na hora do submit. Sem campo
 *   escondido, um submit nativo (JS quebrado, bloqueador) manda a camisa LIMPA: nunca fica
 *   gravada a promessa de um patch que nao foi cobrado.
 * - NAO toca em window.fetch nem em XMLHttpRequest.
 * - NAO le o <h1> nem o titulo do produto (o <h1> e reescrito pelo Worker com o nome do
 *   clube; ler dali poria nome de marca dentro do pedido).
 * - NAO formata dinheiro. Os totais ja vem prontos do Liquid (filtro money), um por
 *   quantidade possivel, em data-md-patches-totais. Assim moeda, simbolo, posicao e
 *   arredondamento continuam sendo os do mercado que a Shopify esta servindo.
 * - NAO escreve nome de patch em lugar nenhum que va pra Shopify. O resumo do topo le o
 *   texto que estiver no alvo naquele instante: o codigo antes do Worker responder, o nome
 *   depois.
 */

(function () {
  'use strict';

  var SEL_BLOCO = '[data-md-patches]';
  var SEL_CHECK = 'input[data-md-patch-codigo]';
  var SEL_ITEM = '.md-patches__item';
  var CLASSE_MARCADO = 'md-patches__item--marcado';

  function achar(raiz, seletor) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(seletor));
  }

  function checks(bloco) {
    return achar(bloco, SEL_CHECK);
  }

  function marcados(bloco) {
    return checks(bloco).filter(function (entrada) {
      return entrada.checked;
    });
  }

  function totais(bloco) {
    return (bloco.getAttribute('data-md-patches-totais') || '').split('|');
  }

  /* O texto do resumo e o que estiver no alvo AGORA: codigo antes do Worker, nome depois.
     Nada de nome de patch nasce deste arquivo. */
  function rotuloDe(entrada) {
    var item = entrada.closest(SEL_ITEM);
    var alvo = item ? item.querySelector('[data-md-patch-campo="n"]') : null;
    var texto = alvo ? (alvo.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return texto || entrada.getAttribute('data-md-patch-codigo') || '';
  }

  /* exclusivo DENTRO do mesmo local, multiplo ENTRE locais diferentes */
  function aplicarExclusividade(bloco, alvo) {
    if (!alvo.checked) return;
    var local = alvo.getAttribute('data-md-patch-local');
    checks(bloco).forEach(function (entrada) {
      if (entrada !== alvo && entrada.getAttribute('data-md-patch-local') === local) {
        entrada.checked = false;
      }
    });
  }

  /* desmarcar o marcado e o toggle nativo do checkbox: nao ha codigo pra isso */

  function pintar(bloco) {
    var selecionados = marcados(bloco);

    checks(bloco).forEach(function (entrada) {
      var item = entrada.closest(SEL_ITEM);
      if (item) item.classList.toggle(CLASSE_MARCADO, entrada.checked);
    });

    /* Resumo na ORDEM DO DOM, nao na ordem do clique: e a ordem em que os patches
       aparecem na lista, e e o que a referencia faz. */
    var resumo = bloco.querySelector('[data-md-patches-resumo]');
    if (resumo) {
      resumo.textContent = selecionados.map(rotuloDe).join(' + ');
    }

    var tabela = totais(bloco);
    var valor = selecionados.length ? tabela[selecionados.length - 1] || '' : '';

    var extra = bloco.querySelector('[data-md-patches-extra]');
    if (extra) {
      if (selecionados.length === 0) {
        extra.textContent = extra.getAttribute('data-md-patches-inicial') || '';
      } else {
        extra.textContent = valor;
      }
    }

    /*
      A sublinha do cabecalho FECHADO. Ela e o unico lugar em que a escolha aparece sem
      o cliente reabrir o acordeao, entao carrega a contagem e o total. Medido na
      referencia: eles trocam "5 disponiveis para este modelo" por "2 selecionados" e
      mantem o texto trocado depois de fechar. O total e nosso (la o patch e de graca).

      A sublinha mora FORA de [data-md-patches-lista], que e o unico no observado pelo
      MutationObserver - por isso escrever nela nao realimenta a observacao.
    */
    var sub = bloco.querySelector('[data-md-patches-sub]');
    if (sub) {
      if (selecionados.length === 0) {
        sub.textContent = sub.getAttribute('data-md-patches-sub-inicial') || '';
      } else {
        var modelo =
          selecionados.length === 1
            ? sub.getAttribute('data-md-patches-sub-um') || '1 selected'
            : sub.getAttribute('data-md-patches-sub-varios') || '[[n]] selected';
        var texto = modelo.replace('[[n]]', String(selecionados.length));
        sub.textContent = valor ? texto + '  ' + valor : texto;
      }
    }
  }

  /* ---------- abrir e fechar ----------
     O estado mora numa classe no <fieldset> (o CSS anima grid-template-rows a partir
     dela) e no aria-expanded do <button>, que e o que o leitor de tela le. */
  function alternar(bloco, trigger, abrir) {
    var aberto = typeof abrir === 'boolean' ? abrir : !bloco.classList.contains('is-open');
    bloco.classList.toggle('is-open', aberto);
    trigger.setAttribute('aria-expanded', aberto ? 'true' : 'false');
  }

  /*
    O Worker troca o texto dos alvos depois que a pagina ja desenhou. Observar a LISTA
    (nunca o bloco inteiro) e o que evita laco: o resumo que esta funcao escreve mora no
    rotulo do topo, FORA da area observada. E como o observer olha childList/characterData
    e nao attributes, a classe que pintar() poe no item tambem nao realimenta.
  */
  function observarRotulos(bloco) {
    var lista = bloco.querySelector('[data-md-patches-lista]');
    if (!lista || typeof MutationObserver !== 'function') return;
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      window.requestAnimationFrame(function () {
        agendado = false;
        pintar(bloco);
      });
    }).observe(lista, { childList: true, characterData: true, subtree: true });
  }

  function iniciar(bloco) {
    if (bloco.dataset.mdPatchesPronto === '1') return;
    bloco.dataset.mdPatchesPronto = '1';

    var extra = bloco.querySelector('[data-md-patches-extra]');
    if (extra) {
      extra.setAttribute('data-md-patches-inicial', (extra.textContent || '').trim());
    }

    var trigger = bloco.querySelector('[data-md-patches-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        alternar(bloco, trigger);
      });

      /* No editor de tema, selecionar o bloco abre o acordeao: senao o Ivan clica no
         bloco na barra lateral e a tela nao mostra nada. Mesmo tratamento do md-faq. */
      document.addEventListener('shopify:block:select', function (evento) {
        if (evento.target && evento.target.contains && evento.target.contains(bloco)) {
          alternar(bloco, trigger, true);
        }
      });
    }

    bloco.addEventListener('change', function (evento) {
      var alvo = evento.target;
      if (!alvo || !alvo.hasAttribute || !alvo.hasAttribute('data-md-patch-codigo')) return;
      aplicarExclusividade(bloco, alvo);
      pintar(bloco);
    });

    observarRotulos(bloco);
    pintar(bloco);
  }

  function iniciarTodos() {
    achar(document, SEL_BLOCO).forEach(iniciar);
  }

  document.addEventListener('shopify:section:load', iniciarTodos);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
})();
